module.exports = __webpack_public_path__ + "static/media/Trained Fertilizer Applicator Training.045be0c5.pdf";